<template>
  <section class="products-index">
    <commercial-list
      :items="items"
      :actions="actions"
      :rules="financingProductRules"
    />
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import CommercialListButton from '@/views/Settings/Commercial/List/Button.vue';
  import CommercialList from '@/views/Settings/Commercial/List.vue';

  export default {
    name: 'ProductsIndex',
    components: {
      CommercialList,
    },
    data() {
      return {
        nav: {
          action: CommercialListButton,
        },
        items: [{
          id: 'includeFinancialProtectionInsurance',
          label: 'Incluir Seguro de Proteção Financeira?',
          field: 'include_financial_protection_insurance',
          formatter: value => (value ? 'Sim' : 'Não'),
        }, {
          id: 'includeCapitalizationBond',
          label: 'Incluir Título de Capitalização?',
          field: 'include_capitalization_bond',
          formatter: value => (value ? 'Sim' : 'Não'),
        }, {
          id: 'includeAssetInsurance',
          label: 'Incluir Seguro do Bem?',
          field: 'include_asset_insurance',
          formatter: value => (value ? 'Sim' : 'Não'),
        }, {
          id: 'includePersonalInsurance',
          label: 'Incluir Seguro de Acidentes?',
          field: 'include_personal_insurance',
          formatter: value => (value ? 'Sim' : 'Não'),
        }],
        actions: {
          update: 'settings-commercial-products-update',
          delete: 'financingProductRules/delete',
        },
      };
    },
    computed: {
      ...mapState([
        'financingProductRules',
      ]),
    },
    mounted() {
      this.getProducts();
    },
    methods: {
      getProducts() {
        this.$store
          .dispatch('financingProductRules/list', { per_page: 99999 });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
